// extracted by mini-css-extract-plugin
module.exports = {"animationL":"animationL_animationL___wM9d"};